/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer } from 'mobx-react';
import Grid from '@material-ui/core/Grid';
import { TextField, Box, Typography } from '@material-ui/core';
import { shapes } from '@greenville/framework';
import { FormattedMessage } from 'react-intl';
import { toJS } from 'mobx';
import Paper from '@material-ui/core/Paper';
import PropTypes from 'prop-types';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import Fab from '@material-ui/core/Fab';
import NavigationIcon from '@material-ui/icons/Navigation';
import FormLabel from '@material-ui/core/FormLabel';
// import * as Constants from '../../../../common/constants';
import utils from '../../../../common/utils';
import ContactInformation from '../common/ContactInformation';
import PublishingCompany from '../common/PublishingCompany';
import ParentInformation from '../common/ParentInformation';
import MetaData from '../../models/MetaData';
import NewRequest from '../../models/NewRequest';
import EtextOptions from '../common/EtextOptions';
import EtextHotspot from '../common/EtextHotspot';
import EtextGeneral from '../common/EtextGeneral';
import UsersPermissions from '../../../users/models/UsersPermissions';
import TooltipCustom from '../../../../common/components/TooltipCustom';

// import StandardEbook from '../../../contentManager/components/create/StandardEbook';

const styles = (theme) => ({
  root: {
    width: '100%'
  },
  metaRoot: {
    '& .MuiTableCell-root': {
      padding: theme.spacing(0.6)
    }
  },
  paper: {
    padding: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  //   formControl: {
  //     minWidth: 208
  //   },
  historyIcon: {
    cursor: 'pointer'
  },
  tableText: {
    textAlign: 'center',
    color: '#6a7070',
    fontSize: 13
  },
  statusText: {
    textAlign: 'center',
    fontSize: 13
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    padding: '5px'
  },
  formControl: {
    margin: theme.spacing(3)
  },
  width: {
    width: '100%'
  },
  labelRadioGrp: {
    fontSize: 14
  },
  paddingTopZero: {
    paddingTop: 8
  },
  paddingTopZeroCheckbox: {
    paddingTop: 0
  },
  fabBtn: {
    position: 'absolute',
    right: '5px'
  }
});

@inject('metaData', 'requestData', 'userPermissions')
@observer
// eslint-disable-next-line react/prefer-stateless-function
class ConvergenceForm extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    metaData: shapes.modelOf(MetaData).isRequired,
    requestData: shapes.modelOf(NewRequest).isRequired,
    language: shapes.language.isRequired,
    workflowSearchStatus: shapes.state.isRequired,
    workflowHistoryStatus: shapes.state.isRequired,

    userPermissions: shapes.modelOf(UsersPermissions).isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      formFields: {
        requestedBy: '',
        phone: '',
        email: '',
        addlEmail: '',
        parentISBN10: '',
        parentISBN13: '',
        ebookISBN10: '',
        ebookISBN13: '',
        pageCount: '',
        folderFTP: '',
        chargeISBN: '',
        pimsID: '',
        rightLeft: '',
        languageID: '',
        initialComments: '',
        disciplineCodeId: '',
        ipadView: '',
        compositor: '',
        title: '',
        author: '',
        copyright: '',
        divisionID: '',
        etextType: '',
        sourceFile: '',
        coverArt: '',
        tocSpreadSheet: '',
        hotspotUI: '',
        glossarySpreadSheet: '',
        contentsLinks: '',
        indexLinks: '',
        crossRefHotspot: '',
        hotSpotSpreadSheet: '',
        custIcons: '',
        customBasketSpreadSheet: '',
        underlineHotspotHoverHex: '',
        underlineHotspotHex: '',
        audio: '',
        itemsExcludeDesc: '',
        retainCaptionList: '',
        additionalNotes: '',
        suppSectionDesc: '',
        underlineHexValue: '',
        others: '',
        coverArtRadioValueBool: false,
        publishRadioValueBool: false,
        eTextRadioValueBool: false,
        eTextDisciplineBool: false,
        sourceFileRadioValueBool: false,
        tocRadioValueBool: false,
        hotspotRadioValueBool: false,
        eTextLanguage: false,
        divisionSource: '',
        otherText: '',
        assetsMaskedRemoved: 'N',
        insideFaceCover: 'N',
        insideBackCover: 'N',
        colorInserts: 'N',
        bonusChapters: 'N',
        tearCard: 'N',
        endPapers: 'N',
        othersCheck: 'N',
        underlineHotspot: 'N',
        underlineHotspotHover: 'N',
        PlsSelectValue: '',
        visibleHotspotHex: ''
      },
      revisionProps: {
        revisionBool: false
      },
      formErrorFields: {
        requestedByError: '',
        phoneError: '',
        emailError: '',
        parentISBN10Error: '',
        parentISBN13Error: '',
        titleError: '',
        authorError: '',
        copyrightError: '',
        ebookISBN10Error: '',
        ebookISBN13Error: '',
        pageCountError: '',
        folderFTPError: '',
        compositorError: ''
      }
    };
  }

  componentDidMount = () => {
    const { metaData } = this.props;

    if (metaData.disciplineCode.length === 0) {
      metaData.fetchDisciplineCodeDropdownValues();
    }
    if (metaData.artAndScience.length === 0) {
      metaData.setArtsAndScience();
    }
    if (metaData.professionalAndCareer.length === 0) {
      metaData.setProfessionalAndCareer();
    }
    if (metaData.international.length === 0) {
      metaData.setInternational();
    }
    if (metaData.ptg.length === 0) {
      metaData.setPtg();
    }
    if (metaData.languages.length === 0) {
      metaData.fetchLanguages();
    }
  };

  handleChange = (event) => {
    const { formFields, formErrorFields } = this.state;
    const temp = formFields;
    const temperror = formErrorFields;

    if (event.target.name === 'pageCount') {
      temp[event.target.name] = parseInt(event.target.value, 10);
    } else {
      temp[event.target.name] = event.target.value;
    }

    if (event.target.name === 'disciplineCodeId' && temp.disciplineCodeId > 0) {
      temp.eTextDisciplineBool = false;
    }
    if (event.target.name === 'languageID' && temp.languageID > 40) {
      temp.eTextLanguage = false;
    }
    temperror[`${event.target.name}Error`] = '';
    this.setState({
      formFields: temp,
      formErrorFields: temperror
    });
  };

  handleRadioChange = (event) => {
    const { formFields } = this.state;
    const temp = formFields;

    if (temp.divisionID <= 25 && event.target.name === 'divisionID') {
      temp.divisionSource = '';
    }

    if (event.target.name === 'divisionID') {
      temp[event.target.name] = parseInt(event.target.value, 10);
    } else {
      temp[event.target.name] = event.target.value;
    }

    if (event.target.name === 'etextType') {
      temp.eTextRadioValueBool = false;
    } else if (event.target.name === 'coverArt') {
      temp.coverArtRadioValueBool = false;
    } else if (event.target.name === 'sourceFile') {
      temp.sourceFileRadioValueBool = false;
    } else if (event.target.name === 'tocSpreadSheet') {
      temp.tocRadioValueBool = false;
    } else if (event.target.name === 'hotspotUI') {
      temp.hotspotRadioValueBool = false;
    } else if (event.target.name === 'divisionID' && temp.divisionSource.length >= 0) {
      temp.publishRadioValueBool = false;
    }

    if (temp.divisionSource.length >= 0 && event.target.name === 'divisionID') {
      temp.publishRadioValueBool = true;
    }
    if (temp.divisionID === 25) {
      temp.publishRadioValueBool = false;
    }

    this.setState({
      formFields: temp
    });
  };

  handleSelectionChange = (event) => {
    const { formFields } = this.state;
    const temp = formFields;
    temp.divisionSource = event.target.value;
    temp.publishRadioValueBool = false;

    this.setState({
      formFields: temp
    });
  };

  handleCheckbox = (e) => {
    const { formFields } = this.state;
    const tempCheck = formFields;
    tempCheck.assetsMaskedRemoved = e.target.checked ? 'Y' : 'N';
    this.setState({
      formFields: tempCheck
    });
  };

  handleCheckboxSection = (e) => {
    const { formFields } = this.state;
    const tempCheck = formFields;
    tempCheck[e.target.name] = e.target.checked ? 'Y' : 'N';
    this.setState({
      formFields: tempCheck
    });
  };

  getInitialState = () => {
    const initialState = {
      requestedBy: '',
      requestedByError: '',
      phone: '',
      itemsExcludeDesc: '',
      initialComments: '',
      email: '',
      addlEmail: '',
      parentISBN10: '',
      parentISBN13: '',
      title: '',
      author: '',
      copyright: '',
      publishRadioValueBool: false,
      eTextRadioValueBool: false,
      coverArtRadioValueBool: false,
      sourceFileRadioValueBool: false,
      tocRadioValueBool: false,
      hotspotRadioValueBool: false,
      ebookISBN10: '',
      ebookISBN13: '',
      pageCount: '',
      folderFTP: '',
      chargeISBN: '',
      pimsID: '',
      rightLeft: '',
      disciplineCodeId: '',
      languageID: '',
      ipadView: '',
      compositor: '',
      divisionID: '',
      divisionSource: '',
      etextType: '',
      tocSpreadSheet: '',
      hotspotUI: '',
      sourceFile: '',
      coverArt: '',
      glossarySpreadSheet: '',
      contentsLinks: '',
      indexLinks: '',
      crossRefHotspot: '',
      hotSpotSpreadSheet: '',
      custIcons: '',
      customBasketSpreadSheet: '',
      audio: '',
      retainCaptionList: '',
      additionalNotes: '',
      suppSectionDesc: '',
      otherText: '',
      underlineHexValue: '',
      others: '',
      assetsMaskedRemoved: 'N',
      insideFaceCover: 'N',
      insideBackCover: 'N',
      colorInserts: 'N',
      bonusChapters: 'N',
      tearCard: 'N',
      endPapers: 'N',
      othersCheck: 'N',
      underlineHotspot: 'N',
      underlineHotspotHover: 'N',
      underlineHotspotHex: '',
      underlineHotspotHoverHex: '',
      visibleHotspotHex: ''
    };
    return initialState;
  };

  getInitialErrorState = () => {
    const initialErrorState = {
      requestedByError: '',
      phoneError: '',
      emailError: '',
      // addlEmailError: '',
      parentISBN10Error: '',
      parentISBN13Error: '',
      titleError: '',
      authorError: '',
      copyrightError: '',
      ebookISBN10Error: '',
      ebookISBN13Error: '',
      pageCountError: '',
      folderFTPError: '',
      compositorError: ''
    };
    return initialErrorState;
  };

  validateRequired = (value) => {
    const { formFields } = this.state;
    return (
      formFields[value] === null ||
      formFields[value].length === 0 ||
      formFields[value].length === '' ||
      formFields[value].length === '' ||
      formFields[value] === 0 ||
      formFields[value] === '0' ||
      formFields[value] === '' ||
      formFields[value] === ''
    );
  };

  validateSave = (requiredArr) => {
    let bool = true;
    let required = false;
    const { formErrorFields } = this.state;
    Object.keys(requiredArr).forEach((fieldError) => {
      const field = fieldError.replace('Error', '');
      required = this.validateRequired(field);
      if (required) {
        bool = false;
        const temp = formErrorFields;
        temp[`${field}Error`] = 'Required';
        this.setState({
          formErrorFields: temp
        });
      }
    });
    return bool;
  };

  handleSave = () => {
    const { formFields, formErrorFields } = this.state;
    this.validateSave(formErrorFields);
    const temp = formFields;

    if (formFields.divisionID === '') {
      temp.publishRadioValueBool = true;
    }
    if (formFields.divisionSource === '') {
      temp.publishRadioValueBool = true;
    }
    if (formFields.etextType.length === 0) {
      temp.eTextRadioValueBool = true;
    }
    if (formFields.sourceFile.length === 0) {
      temp.sourceFileRadioValueBool = true;
    }
    if (formFields.coverArt.length === 0) {
      temp.coverArtRadioValueBool = true;
    }
    if (formFields.tocSpreadSheet.length === 0) {
      temp.tocRadioValueBool = true;
    }
    if (formFields.hotspotUI.length === 0) {
      temp.hotspotRadioValueBool = true;
    }
    if (formFields.divisionID === 25) {
      temp.publishRadioValueBool = false;
    }
    if (formFields.disciplineCodeId === 0 || formFields.disciplineCodeId === '') {
      temp.eTextDisciplineBool = true;
    }
    if (formFields.languageID === '') {
      temp.eTextLanguage = true;
    }
    this.setState({
      formFields: temp
    });

    const errIdx = Object.values(formErrorFields).indexOf('Required');
    if (errIdx >= 0) {
      const elementName = Object.keys(formErrorFields)[errIdx].replace('Error', '');
      document.querySelectorAll(`[name='${elementName}']`)[0].scrollIntoView({ block: 'center' });
    }

    if (
      formFields.publishRadioValueBool === false &&
      formFields.eTextRadioValueBool === false &&
      formFields.sourceFileRadioValueBool === false &&
      formFields.coverArtRadioValueBool === false &&
      formFields.tocRadioValueBool === false &&
      formFields.hotspotRadioValueBool === false &&
      formFields.eTextLanguage === false &&
      formFields.eTextDisciplineBool === false &&
      errIdx === -1
    ) {
      const payload = {
        data: {
          ...formFields,
          heOrSch: 'H',
          statusText: 'Initiation',
          statusID: 1,
          source: formFields.divisionID,
          divisionSource: formFields.divisionSource.toString()
        }
      };
      const {
        requestData: { savePayload }
      } = this.props;
      savePayload(payload);
    }
  };

  handleClear = () => {
    this.setState({
      formFields: this.getInitialState(),
      formErrorFields: this.getInitialErrorState()
    });
  };

  render() {
    const { language, classes, metaData, userPermissions } = this.props;
    const { formFields, formErrorFields, divisionID, publishRadioValueBool, revisionProps } = this.state;
    let disciplineCode = [];
    if (metaData.disciplineCode.length > 0) {
      disciplineCode = utils.disciplineCodeStructure(metaData.disciplineCode);
    }
    const permissionsList = toJS(userPermissions.permissionList.permissions);

    return (
      <>
        <br />
        <Typography align="center" variant="h2">
          <FormattedMessage {...language.getText('eTextrequest.TEXT')} />
          <span>
            <Fab variant="extended" color="primary" className={classes.fabBtn}>
              <NavigationIcon className={classes.extendedIcon} />
              FAQ ?
            </Fab>
          </span>
        </Typography>

        <Paper elevation={3}>
          <Box my={2} mx={2} p={2} pb={4}>
            <ContactInformation
              formErrorFields={formErrorFields}
              formFields={formFields}
              handleChange={($event) => this.handleChange($event)}
            />
            <PublishingCompany
              formErrorFields={formErrorFields}
              formFields={formFields}
              handleChange={($event) => this.handleChange($event)}
              handleRadioChange={($event) => this.handleRadioChange($event)}
              divisionID={divisionID}
              publishRadioValueBool={publishRadioValueBool}
              handleSelectionChange={($event) => this.handleSelectionChange($event)}
              artsAndScience={metaData.artAndScience}
              professionalAndCareer={metaData.professionalAndCareer}
              international={metaData.international}
              ptg={metaData.ptg}
            />
          </Box>
        </Paper>

        <Paper elevation={3}>
          <Box my={2} mx={2} p={2} pb={4}>
            <ParentInformation
              formErrorFields={formErrorFields}
              formFields={formFields}
              handleChange={($event) => this.handleChange($event)}
              revisionProps={revisionProps}
            />
            <br />
            <EtextGeneral
              formFields={formFields}
              handleRadioChange={($event) => this.handleRadioChange($event)}
              handleChange={($event) => this.handleChange($event)}
              formErrorFields={formErrorFields}
              disciplineCode={disciplineCode}
              languages={metaData.languages}
            />
          </Box>
        </Paper>
        <Typography align="center" variant="h2">
          <FormattedMessage {...language.getText('eTextrequest.COVER')} />
        </Typography>
        <Paper elevation={3}>
          <Box my={2} mx={5} p={2} pb={4}>
            <Typography align="center" variant="subtitle2" gutterBottom>
              <FormattedMessage {...language.getText('eTextrequest.COVERARTWORKTXT')} />
            </Typography>
            <Typography align="center" variant="subtitle2" gutterBottom>
              <b>
                <FormattedMessage {...language.getText('eTextrequest.COVERARTWORKTXTNOTE')} />
              </b>
            </Typography>
            <br />
            <Grid container direction="row" spacing={5}>
              <Grid container item xs={12} direction="column">
                <FormControl size="small" margin="dense" component="fieldset">
                  <FormLabel component="span">
                    {' '}
                    <Typography variant="body2">
                      <FormattedMessage {...language.getText('eTextrequest.ARTWORK')} />
                      <span> * </span>
                      {formFields.coverArtRadioValueBool ? (
                        <Typography variant="caption">
                          <span style={{ color: '#ca4644' }} id="req_text">
                            {' '}
                            <FormattedMessage {...language.getText('eTextconvergence.ATLEAST')} />
                          </span>
                        </Typography>
                      ) : null}
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="coverArt"
                    onChange={($event) => this.handleRadioChange($event)}
                    name="coverArt"
                    value={formFields.coverArt}
                  >
                    <FormControlLabel
                      value="Supplied"
                      control={<Radio color="primary" />}
                      label={<FormattedMessage {...language.getText('eTextconvergence.SUPPLIED')} />}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="Not supplied"
                      control={<Radio color="primary" />}
                      label={<FormattedMessage {...language.getText('eTextconvergence.NOTSUPPLIED')} />}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <Typography align="center" variant="h2">
          <FormattedMessage {...language.getText('eTextrequest.REQUIRED')} />
        </Typography>
        <Paper elevation={3}>
          <Box my={2} mx={5} p={2} pb={4}>
            <Grid container direction="row" spacing={5}>
              <Grid container item xs={12} direction="column">
                <FormControl margin="dense">
                  <FormLabel>
                    <Typography variant="h5">
                      <FormattedMessage {...language.getText('eTextrequest.TOC')} />
                      <span> * </span>
                      {formFields.tocRadioValueBool ? (
                        <Typography variant="caption">
                          <span style={{ color: '#ca4644' }} id="req_text">
                            {' '}
                            <FormattedMessage {...language.getText('eTextconvergence.ATLEAST')} />
                          </span>
                        </Typography>
                      ) : null}
                    </Typography>
                  </FormLabel>
                  <RadioGroup
                    row
                    aria-label="tocSpreadSheet"
                    onChange={($event) => this.handleRadioChange($event)}
                    name="tocSpreadSheet"
                    value={formFields.tocSpreadSheet}
                  >
                    <FormControlLabel
                      value="Supplied"
                      control={<Radio color="primary" />}
                      label={<FormattedMessage {...language.getText('eTextconvergence.SUPPLIED')} />}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="Not needed (XML from ETM is complete)"
                      control={<Radio color="primary" />}
                      label={<FormattedMessage {...language.getText('eTextconvergence.NOTNEEDED')} />}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="Not supplied (vendor will create from TOC PDF)"
                      control={<Radio color="primary" />}
                      label={<FormattedMessage {...language.getText('eTextconvergence.NOTSUPPLIEDVENDOR')} />}
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="Not supplied (vendor will use pagination chart)"
                      control={<Radio color="primary" />}
                      label={<FormattedMessage {...language.getText('eTextconvergence.SUPPLYADDITIONAL')} />}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <Typography align="center" variant="h2">
          <FormattedMessage {...language.getText('eTextrequest.eTEXTOPTION')} />
        </Typography>
        <Paper elevation={3}>
          <Box my={2} mx={5} p={2} pb={4}>
            <EtextOptions formFields={formFields} handleRadioChange={($event) => this.handleRadioChange($event)} />
          </Box>
        </Paper>

        <Paper elevation={3}>
          <Box my={2} mx={5} p={2} pb={4}>
            <EtextHotspot
              formErrorFields={formErrorFields}
              formFields={formFields}
              handleRadioChange={($event) => this.handleRadioChange($event)}
              handleChange={($event) => this.handleChange($event)}
              handleCheckboxSection={($event) => this.handleCheckboxSection($event)}
            />
          </Box>
        </Paper>

        <Typography align="center" variant="h2">
          <FormattedMessage {...language.getText('eTextrequest.SPECIAL')} />
        </Typography>
        <Paper elevation={3}>
          <Box my={2} mx={5} p={2} pb={4}>
            <Grid container direction="row" spacing={5}>
              <Grid container item xs={11} direction="column">
                <Typography variant="subtitle1" gutterBottom>
                  <FormattedMessage {...language.getText('eTextrequest.SPECIALTXT')} />
                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                  <FormattedMessage {...language.getText('eTextrequest.SPECIALTXTBOOKS')} />
                </Typography>
                <br />

                <FormControl component="fieldset">
                  <FormLabel component="legend">
                    <Typography variant="h5">(check all that apply)</Typography>
                  </FormLabel>
                  <FormGroup
                    row
                    aria-label="coverArtRadioValue"
                    onChange={(e) => this.handleCheckboxSection(e)}
                    value={formFields.coverArtRadioValue}
                  >
                    <FormControlLabel
                      value="inside"
                      control={
                        <Checkbox
                          checked={formFields.insideFaceCover === 'Y'}
                          name="insideFaceCover"
                          className={classes.paddingTopZeroCheckbox}
                          color="primary"
                        />
                      }
                      label="Inside Front Cover"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      value="inside"
                      control={
                        <Checkbox
                          checked={formFields.insideBackCover === 'Y'}
                          name="insideBackCover"
                          className={classes.paddingTopZeroCheckbox}
                          color="primary"
                        />
                      }
                      label="Inside Back Cover"
                    />
                    <FormControlLabel
                      value="inside"
                      control={
                        <Checkbox
                          checked={formFields.colorInserts === 'Y'}
                          name="colorInserts"
                          className={classes.paddingTopZeroCheckbox}
                          color="primary"
                        />
                      }
                      label="Color Inserts"
                    />
                    <FormControlLabel
                      value="inside"
                      control={
                        <Checkbox
                          checked={formFields.bonusChapters === 'Y'}
                          name="bonusChapters"
                          className={classes.paddingTopZeroCheckbox}
                          color="primary"
                        />
                      }
                      label="Bonus Chapters"
                    />
                    <FormControlLabel
                      value="inside"
                      control={
                        <Checkbox
                          checked={formFields.tearCard === 'Y'}
                          name="tearCard"
                          className={classes.paddingTopZeroCheckbox}
                          color="primary"
                        />
                      }
                      label="Tear Card"
                    />
                    <FormControlLabel
                      value="inside"
                      control={
                        <Checkbox
                          checked={formFields.endPapers === 'Y'}
                          name="endPapers"
                          className={classes.paddingTopZeroCheckbox}
                          color="primary"
                        />
                      }
                      label="End Papers"
                    />
                    <FormControlLabel
                      value="inside"
                      control={
                        <Checkbox
                          checked={formFields.othersCheck === 'Y'}
                          name="othersCheck"
                          className={classes.paddingTopZeroCheckbox}
                          color="primary"
                        />
                      }
                      label="Others"
                    />
                  </FormGroup>
                  <TextField
                    name="others"
                    value={formFields.others}
                    onChange={($event) => this.handleChange($event)}
                    margin="dense"
                    variant="outlined"
                  />
                </FormControl>
                <Typography variant="subtitle1" gutterBottom>
                  <FormattedMessage {...language.getText('eTextrequest.SPECIALSUBTXT')} />
                </Typography>
                <TextareaAutosize
                  aria-label="minimum height"
                  rowsMin={6}
                  name="suppSectionDesc"
                  onChange={($event) => this.handleChange($event)}
                  value={formFields.suppSectionDesc}
                />
              </Grid>
            </Grid>
          </Box>
        </Paper>
        <Typography align="center" variant="h2">
          <FormattedMessage {...language.getText('eTextrequest.RIGHTS')} />
        </Typography>
        <Paper elevation={3}>
          <Box my={2} mx={5} p={2} pb={4}>
            <Grid container direction="row" spacing={5}>
              <Grid container item xs={12} direction="column">
                {/* DO NOT DELETE
                <Typography align="center" variant="h5">
                  <FormattedMessage {...language.getText('eTextrequest.UPLOAD_SOURCE_FILES')} />
                </Typography>

                <StandardEbook {...this.props} isCMScreen={false} /> */}
                {/* <Typography variant="subtitle2" gutterBottom>
                  <FormattedMessage {...language.getText('eTextrequest.CORPOARATERIGHTS')} />
                </Typography>
                <br />
                <Typography variant="subtitle2">
                  <FormattedMessage {...language.getText('eTextrequest.UPLOAD')} />
                  <span> * </span>
                </Typography> */}
                {/* <TextField
                  // label="Name"
                  disabled="true"
                  type="file"
                  helperText="(Required only for Arts & Science, or Profession & Career eTexts. Not required for International, PTG, or PLS eTexts.)"
                  margin="dense"
                  name="Upload"
                  onChange={($event) => this.handleChange(null, null, $event)}
                  // value={formFields.rightsAndPerDesc}
                  variant="outlined"
                /> */}
                <br />
                <br />
                <FormControl component="fieldset" className={classes.labelName}>
                  <FormGroup row className={classes.labelName} onChange={(e) => this.handleCheckbox(e)}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={formFields.assetsMaskedRemoved === 'Y'}
                          name="assetsMaskedRemoved"
                          className={classes.paddingTopZeroCheckbox}
                          color="primary"
                        />
                      }
                      label="Book contains assets to be masked/removed."
                    />
                  </FormGroup>
                </FormControl>
                <Typography variant="subtitle1" gutterBottom>
                  <FormattedMessage {...language.getText('eTextrequest.COPYdESC')} />
                </Typography>
                <TextareaAutosize
                  aria-label="minimum height"
                  rowsMin={6}
                  name="itemsExcludeDesc"
                  onChange={($event) => this.handleChange($event)}
                  value={formFields.itemsExcludeDesc}
                />
                <br />
                <Typography variant="subtitle2" gutterBottom>
                  <FormattedMessage {...language.getText('eTextrequest.RETAINCAPTION')} />
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  <FormattedMessage {...language.getText('eTextrequest.RETAINITEMS')} />
                </Typography>
                <TextareaAutosize
                  aria-label="minimum height"
                  rowsMin={6}
                  name="retainCaptionList"
                  onChange={($event) => this.handleChange($event)}
                  value={formFields.retainCaptionList}
                />
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <Typography align="center" variant="h2">
          <FormattedMessage {...language.getText('eTextrequest.COMMENTS')} />
        </Typography>
        <Paper elevation={3}>
          <Box my={2} mx={5} p={2} pb={4}>
            <Grid container direction="row" spacing={5}>
              <Grid container item xs={12} direction="column">
                <TextareaAutosize
                  placeholder="Please provide additional details here regarding the location of Source Assets or PDFs. Along with the additional comments (If any)."
                  aria-label="minimum height"
                  rowsMin={6}
                  name="additionalNotes"
                  onChange={($event) => this.handleChange($event)}
                  value={formFields.additionalNotes}
                />
                <br />
              </Grid>
              <Grid container justify="space-evenly">
                <TooltipCustom
                  title={
                    !permissionsList.includes('etext_can_edit') ? (
                      <FormattedMessage {...language.getText('user.PERMISSIONS_LABEL')} />
                    ) : (
                      <FormattedMessage {...language.getText('eTextconversion.SUBMIT_ETEXT_CONVERSION')} />
                    )
                  }
                >
                  <span>
                    <Button
                      variant="outlined"
                      size="small"
                      color="primary"
                      onClick={this.handleSave}
                      disabled={!permissionsList.includes('etext_can_edit')}
                    >
                      <FormattedMessage {...language.getText('contentmanager.SUBMIT')} />
                    </Button>
                  </span>
                </TooltipCustom>
                <TooltipCustom title={<FormattedMessage {...language.getText('common.RESET_ALL_FIELDS')} />}>
                  <Button variant="outlined" size="small" color="primary" onClick={this.handleClear}>
                    <FormattedMessage {...language.getText('common.CLEARFORM')} />
                  </Button>
                </TooltipCustom>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </>
    );
  }
}

export default withStyles(styles)(observer(inject('language')(ConvergenceForm)));
